const visibility = {
  all: 'All',
  internal: 'Internal',
  external: 'External'
};

export default visibility;
